import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RBCheck } from '@ldw/roesberg';
import { LdwRouterService } from '../route/ldw-router.service';
import { TranslateService } from '@ngx-translate/core';
import { LinkErrorDialogComponent } from '../shared/dialogs/link-error-dialog/link-error-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'ldw-link',
    templateUrl: './component.html',
    styleUrls: ['./component.css'],
    standalone: false
})
export class LinkComponent implements OnInit {
  translate = inject(TranslateService);
  protected routerService = inject(LdwRouterService);
  protected route = inject(ActivatedRoute);
  private dialog = inject(MatDialog);

  public isActive = false;
  public ldwLink = '';

  ngOnInit(): void {
    if (this.routerService.wasPermaLink) {
      this.routerService.navigateToWebDokuSelection();
      return;
    }
    this.routerService.wasPermaLink = true;

    this.isActive = true;
    this.ldwLink = window.location.href;
    const webDokuId = this.route.snapshot.queryParams['webdokuid'] ?? '';
    const docNodeId = this.route.snapshot.queryParams['docnodeid'] ?? '';
    const pltNodeId = this.route.snapshot.queryParams['pltnodeid'] ?? '';
    const custNodeId = this.route.snapshot.queryParams['custnodeid'] ?? '';
    const docId = this.route.snapshot.queryParams['docid'] ?? '';
    const docPage = this.route.snapshot.queryParams['docpage'] ?? '';

    if (RBCheck.isNullOrEmpty(webDokuId)) {
      this.showError('LINK.WEBDOKUEMPTY');
      return;
    }

    // -------------------------------------------------------
    // from here on all errors are resolved in navigated pages
    // -------------------------------------------------------
    if (!RBCheck.isNullOrEmpty(docId)) {
      this.routerService.navigateToDocumentViewer(docId, webDokuId, docPage);
      return;
    }

    if (!RBCheck.isNullOrEmpty(pltNodeId)) {
      this.routerService.navigateToBasic(webDokuId, pltNodeId);
      return;
    }

    if (!RBCheck.isNullOrEmpty(docNodeId)) {
      this.routerService.navigateToDocuments(webDokuId, docNodeId);
      return;
    }

    if (!RBCheck.isNullOrEmpty(custNodeId)) {
      this.routerService.navigateToCustomNavigation(webDokuId, docNodeId);
      return;
    }

    // fallback as at least webDoku is given
    this.routerService.navigateToDocuments(webDokuId, '');
  }

  protected showError(text: string) {
    this.isActive = false;
    console.log(`can not resolve link for '${this.ldwLink}'`);
    console.log('error: ' + this.translate.instant(text));
    const errorDialog = this.dialog.open(LinkErrorDialogComponent, {
      data: {
        message: text,
        linktext: this.ldwLink,
      },
    });
    errorDialog.afterClosed().subscribe(() => {
      this.routerService.navigateToWebDokuSelection();
    });
  }
}
